<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" class="dialog-w40" :class="$style['import']">
    <div v-if="completed">
      <h2 class="text-center mt-0">Импорт завершен</h2>
      <h3>Добавлено заказов: {{newOrderIds.length}}</h3>
      <template v-if="problems.length">
        <h4>Не удалось импортировать:</h4>
        <el-table max-height="300" :data="problems" border>
          <el-table-column property="problemLocation.orderNumber" label="Номер заказа" width="150" />
          <el-table-column property="problemLocation.cellReference.value" label="Номер строки или ячейки с заказом на услугу" width="150" />
          <el-table-column property="message" label="Сообщение" width="" />
        </el-table>
      </template>
      <div class="row mt-4">
        <div class="col-12 col-lg-6 mx-auto">
          <el-button class="w-100" type="primary" @click="$emit('update:visible', false)">Ок</el-button>
        </div>
      </div>
    </div>

    <el-form v-else :model="form" :rules="rules" ref="form">
      <h2 class="text-center mt-0">Импорт</h2>
      <template v-if="$isAccess($userRoles.Admin, $userRoles.Specialist)">
        <div class="row">
          <div class="col-12 col-lg-6">
            <h3>Тип реестра</h3>
            <el-form-item prop="registryTypeId">
              <el-select size="medium" filterable collapse-tags
                         class="w-100"
                         v-model="form.registryTypeId"
                         :loading="registryTypesDropFetchProgress"
                         placeholder="Выберите тип реестра">
                <el-option
                  v-for="option in registryTypesDropItems"
                  :key="option.id"
                  :label="option.displayName"
                  :value="option.id.toString()">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-12 col-lg-6">
            <h3>Подрядчик</h3>
            <el-form-item prop="contractorId">
              <el-select size="medium" filterable collapse-tags
                         class="w-100"
                         v-model="form.contractorId"
                         :loading="contractorsDropFetchProgress"
                         placeholder="Выберите подрядчика">
                <el-option
                  v-for="option in contractorsDropItems"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id.toString()">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-12 col-lg-6">
            <h3>Реестр</h3>
            <el-form-item prop="file">
              <el-upload ref="upload" class="w-100"
                         action="/" accept=".xlsx" :limit="1" :auto-upload="false" :on-change="onChangeFile" :on-remove="onRemoveFile">
                <el-button v-if="fileList.length" icon="el-icon-plus" @click.stop size="medium" disabled class="w-100">
                  Прикрепить файл
                </el-button>
                <el-button v-else slot="trigger" icon="el-icon-plus" size="medium" class="w-100">
                  Прикрепить файл
                </el-button>
              </el-upload>
            </el-form-item>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="row">
          <div class="col-12 col-lg-6">
            <h3>Тип реестра</h3>
            <el-form-item prop="registryTypeId">
              <el-select size="medium" filterable collapse-tags
                         class="w-100"
                         v-model="form.registryTypeId"
                         :loading="registryTypesDropFetchProgress"
                         placeholder="Выберите тип реестра">
                <el-option
                  v-for="option in registryTypesDropItems"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id.toString()">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-12 col-lg-6">
            <h3>Реестр</h3>
            <el-form-item prop="file">
              <el-upload ref="upload" class="w-100"
                         action="/" accept=".xlsx" :limit="1" :auto-upload="false" :on-change="onChangeFile" :on-remove="onRemoveFile">
                <el-button v-if="fileList.length" icon="el-icon-plus" @click.stop size="medium" disabled class="w-100">
                  Прикрепить файл
                </el-button>
                <el-button v-else slot="trigger" icon="el-icon-plus" size="medium" class="w-100">
                  Прикрепить файл
                </el-button>
              </el-upload>
            </el-form-item>
          </div>
        </div>
      </template>

      <div class="row mt-3">
        <div class="col-12 col-lg-6 mx-auto">
          <el-button class="w-100" type="primary" @click="onSubmit" :loading="importExportProgress">Отправить</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import { declOfNum } from '@/commons/helpers';

export default {
  props: {
    visible: Boolean,
  },
  data: () => ({
    completed: false,
    fileList: [],
    form: {
      registryTypeId: null,
      contractorId: null,
      file: null,
    },
    newOrderIds: [],
    problems: [],
  }),
  computed: {
    ...mapGetters({
      contractorsDropItems: 'contractorsDrop/items',
      contractorsDropFetchProgress: 'contractorsDrop/fetchProgress',
      registryTypesDropItems: 'registryTypesDrop/notArchivedItems',
      registryTypesDropFetchProgress: 'registryTypesDrop/fetchProgress',
      importExportProgress: 'orders/importExportProgress',
    }),
    rules() {
      if (this.$isAccess(this.$userRoles.Admin)) {
        return {
          registryTypeId: [
            { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
          ],
          contractorId: [
            { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
          ],
          file: [
            { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
          ],
        };
      }
      return {
        registryTypeId: [
          { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        ],
        file: [
          { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        ],
      };
    },
  },
  methods: {
    ...mapActions({
      fetchContractorsItems: 'contractorsDrop/fetchItems',
      fetchRegistryTypesItems: 'registryTypesDrop/fetchItems',
      importOrders: 'orders/importOrders',
    }),
    declOfNum,
    onChangeFile(file, fileList) {
      this.fileList = fileList;
      this.form.file = file.raw;
      this.$refs.form.validate(() => {});
    },
    onRemoveFile(file, fileList) {
      this.fileList = fileList;
      this.form.file = null;
    },
    onSubmit() {
      const { contractorId, registryTypeId } = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = new FormData();
          data.append('formFile', this.form.file);
          this.importOrders({ data, params: { contractorId, registryTypeId } }).then(({ data }) => {
            this.newOrderIds = data.newOrderIds;
            this.problems = data.problems;
            this.completed = true;
          });
        }
      });
    },
  },
  created() {
    this.fetchContractorsItems();
    this.fetchRegistryTypesItems();
  },
};
</script>
<style lang="scss" module>
.import {
  h3 {
    font-size: 16px !important;
    margin: 12px 0;
  }
  h4 {
    margin: 4px 0;
  }
}
</style>
